"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9705],{

/***/ 9705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(3946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 4 modules
var Accordion = __webpack_require__(461);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(8895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(2797);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(953);
// EXTERNAL MODULE: ./public/assets/images/home/GromoLogo.svg
var GromoLogo = __webpack_require__(4001);
// EXTERNAL MODULE: ./public/assets/images/home/playStoreBlack.svg
var playStoreBlack = __webpack_require__(5355);
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_Facebook.webp
/* harmony default export */ var Icon_Facebook = ({"src":"/_next/static/media/Icon_Facebook.3309198b.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBGAAAA8AEAnQEqCAAIAAJAOCWUAnQBHoHh/PYAAP7tKFBXdTN4v6ADNOWKa+lgoQmzFx8Al63B3wPWBzxoDATel90SKyd6MuAAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_WhatsApp.svg
/* harmony default export */ var Icon_WhatsApp = ({"src":"/_next/static/media/Icon_WhatsApp.4f694f89.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_Instagram.webp
/* harmony default export */ var Icon_Instagram = ({"src":"/_next/static/media/Icon_Instagram.0134fd75.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBIAAAA8AEAnQEqCAAIAAJAOCWUAnQFGAN9rc1wAP7qVsOd9XCdhgoA8KHxBjqi47ZUrWpxm03s5E0pqKnaxzwV4i/4R5qyd6MuAAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_LinkedIn.webp
/* harmony default export */ var Icon_LinkedIn = ({"src":"/_next/static/media/Icon_LinkedIn.c298d38f.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBQAAAAUAIAnQEqCAAIAAJAOCWUAnQEwAHfxAjDexlYAP7CrR7+X2hRP7KvnH7Ux8n/ToiBgBfA3ZGT1wznWLDFoA+qAVvq08nG2D74ShjAnpDLgAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_Youtube.webp
/* harmony default export */ var Icon_Youtube = ({"src":"/_next/static/media/Icon_Youtube.0693a340.webp","height":80,"width":80,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6AmABKGXDQkMNfQGhEReId6sIokq7EgkoEh/WcFCEgKwMFdRP9jtt8MOBGuhWQhBfgGnNmfAVZQOCBIAAAAEAIAnQEqCAAIAAJAOCWUAnQBHoJp+iaxwAD+0qcde85X5oSkGwarPgOlCB1s7jz6ncVYcraD+1HU8zQnuMiPHmrJ3o0lgAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/Icon_Telegram.webp
/* harmony default export */ var Icon_Telegram = ({"src":"/_next/static/media/Icon_Telegram.abd8c42e.webp","height":80,"width":80,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6AmABKGXDQkMNfQGhEReId6sIokq7EgkoEh/WcFCEgKwMFdRP9jtt8MOBGuhWQhBfgGnNmfAVZQOCBIAAAA0AEAnQEqCAAIAAJAOCWUAnQA9F9jUIAA/upOJpZ+zWRToPK/Pjxi/V5sVayGN8HDhd56t+PqYggWitip1Ri2L0STpN2G+LgA","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(645);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(813);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(5503);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/AppFooter.tsx







// import appStoreBlack from "../public/assets/images/home/appStoreBlack.svg";











function AppFooter() {
    const [imgSrc, setImgSrc] = (0,react.useState)(ImageExport/* PLAYSTORE_BLACK */.ZE);
    const [moreAbout, setMoreAbout] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        // if (Utils.getOS()?.toLocaleLowerCase() == "android") {
        setImgSrc(ImageExport/* PLAYSTORE_BLACK */.ZE);
    // }
    // else if (Utils.getOS()?.toLocaleLowerCase() == "ios") {
    //   setImgSrc(APPSTORE_BLACK);
    // }
    }, []);
    const router = (0,next_router.useRouter)();
    const redirectToProduct = (redirectUrl)=>{
        localStorage.setItem("hash", redirectUrl);
        setTimeout(()=>{
            router.push("/#our-products");
            setTimeout(()=>{
                router.push("/#".concat(redirectUrl));
            }, 900);
        }, 10);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        id: "contact-us",
        style: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#212736",
            color: "white",
            padding: "3%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                height: "90%",
                width: {
                    xs: "95%",
                    md: "90%"
                },
                display: "flex",
                flexDirection: "column",
                maxWidth: "1440px",
                margin: "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "grid",
                            md: "flex"
                        },
                        height: "fit-content",
                        width: "100%",
                        justifyContent: "space-evenly"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                display: {
                                    xs: "flex",
                                    md: "flex"
                                },
                                flexDirection: {
                                    xs: "column"
                                },
                                width: {
                                    xs: "100%",
                                    md: "35%"
                                },
                                justifyContent: {
                                    xs: "center",
                                    md: "space-between"
                                },
                                alignItems: {
                                    xs: "center",
                                    md: "normal"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: GromoLogo/* default */.Z,
                                        alt: "GroMo logo",
                                        width: 120,
                                        height: 40,
                                        style: {
                                            margin: "10px 0 5px 0"
                                        },
                                        loading: "lazy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "flex",
                                            md: "block"
                                        },
                                        justifyContent: {
                                            xs: "space-between",
                                            md: "center"
                                        },
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            padding: "4px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: {
                                                        xs: "15px",
                                                        md: "18px"
                                                    },
                                                    maxWidth: "1440px",
                                                    display: {
                                                        xs: "none",
                                                        md: "block"
                                                    }
                                                },
                                                children: [
                                                    "Sell financial products & earn ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "₹1 Lakh/month"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            sx: {
                                                margin: "10px 0",
                                                padding: "0",
                                                display: {
                                                    xs: "block",
                                                    md: "flex"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    href: Constants/* appLink */.ze,
                                                    "aria-label": "Get it on Google Play",
                                                    sx: {
                                                        fontSize: "24px",
                                                        display: {
                                                            xs: "none",
                                                            md: "flex"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        width: 140,
                                                        height: 140,
                                                        src: playStoreBlack/* default */.Z,
                                                        alt: "Get it on Google Play",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    href: Constants/* appLink */.ze,
                                                    "aria-label": "Get it on Google Play",
                                                    sx: {
                                                        display: {
                                                            xs: "block",
                                                            md: "none"
                                                        },
                                                        fontSize: "24px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: imgSrc,
                                                        width: 140,
                                                        height: 140,
                                                        alt: "Get it on Google Play",
                                                        style: {
                                                            objectFit: "contain"
                                                        },
                                                        loading: "lazy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "flex",
                                            md: "flex"
                                        },
                                        justifyContent: {
                                            xs: "space-between",
                                            md: "flex-start"
                                        },
                                        alignItems: "center",
                                        margin: {
                                            xs: "0",
                                            md: "10px 0"
                                        }
                                    },
                                    children: [
                                        {
                                            name: "linkedIn",
                                            img: Icon_LinkedIn,
                                            link: "https://www.linkedin.com/company/gromofintech/"
                                        },
                                        {
                                            name: "youtube",
                                            img: Icon_Youtube,
                                            link: "https://www.youtube.com/channel/UCn5RV1XAm2Fpq5CRn_aw21A?sub_confirmation=1"
                                        },
                                        {
                                            name: "facebook",
                                            img: Icon_Facebook,
                                            link: "https://www.facebook.com/gromofintech/"
                                        },
                                        {
                                            name: "twitter",
                                            img: Icon_WhatsApp,
                                            link: "https://whatsapp.com/channel/0029Va9ASKX0gcfGBCh00d0z"
                                        },
                                        {
                                            name: "instagram",
                                            img: Icon_Instagram,
                                            link: "https://www.instagram.com/gromo_official.in?igsh=MWpxaXR6ZGkxemtmbA=="
                                        },
                                        {
                                            name: "telegram",
                                            img: Icon_Telegram,
                                            link: "https://t.me/GroMoFin/"
                                        }
                                    ].map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.link,
                                            target: "_blank",
                                            rel: "preload",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                "aria-label": "social media icons",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.img,
                                                    style: {
                                                        margin: "0px 5px",
                                                        width: 40,
                                                        height: 40,
                                                        objectFit: "contain",
                                                        transform: item.link.includes("whatsapp.com") ? "scale(1.10)" : undefined
                                                    },
                                                    width: 40,
                                                    height: 40,
                                                    loading: "lazy",
                                                    alt: item.name
                                                })
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "45%"
                                },
                                display: "flex",
                                justifyContent: "right"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "45%"
                                        },
                                        paddingBottom: "10px",
                                        borderBottom: "1px solid #212736"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            margin: "10px 0",
                                            color: "#9EA2AE",
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: "Products"
                                        }),
                                        [
                                            {
                                                title: "Credit Card",
                                                redirect: "CreditCard"
                                            },
                                            {
                                                title: "Savings Account",
                                                redirect: "SavingAccount"
                                            },
                                            {
                                                title: "Demat Account",
                                                redirect: "DematAccount"
                                            },
                                            {
                                                title: "Loan",
                                                redirect: "Loan"
                                            },
                                            {
                                                title: "Line of Credit",
                                                redirect: "Credit"
                                            },
                                            {
                                                title: "Investment",
                                                redirect: "Investment"
                                            }
                                        ].map((text, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                sx: {
                                                    display: {
                                                        xs: "block",
                                                        md: "block"
                                                    },
                                                    cursor: "pointer",
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                onClick: ()=>{
                                                    if (text.redirect) {
                                                        redirectToProduct(text.redirect);
                                                    }
                                                },
                                                children: text.title
                                            }, i);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "45%"
                                        },
                                        borderBottom: "1px solid #212736",
                                        paddingBottom: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            margin: "10px 0",
                                            color: "#9EA2AE",
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: "Company"
                                        }),
                                        [
                                            {
                                                text: "Academy",
                                                path: "https://app.gromo.co.in/MFtc"
                                            },
                                            {
                                                text: "Partner with us",
                                                path: Constants/* appLink */.ze
                                            },
                                            {
                                                text: "Blog",
                                                path: "https://gromo.in/blog/"
                                            }
                                        ].map((obj, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: obj.path,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    sx: {
                                                        cursor: "pointer",
                                                        fontSize: {
                                                            xs: "14px",
                                                            md: "16px"
                                                        },
                                                        fontWeight: "500",
                                                        lineHeight: "20px",
                                                        padding: "6px 0"
                                                    },
                                                    children: obj.text
                                                })
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/about-us",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                sx: {
                                                    cursor: "pointer",
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                children: "About us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/careers",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body1",
                                                sx: {
                                                    display: {
                                                        cursor: "pointer"
                                                    },
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                children: [
                                                    "Careers",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            border: "1px solid black",
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            background: "#8DD993",
                                                            color: "black",
                                                            fontWeight: "bold",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                            margin: "0px 5px"
                                                        },
                                                        children: "Hiring!"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "20%"
                                },
                                borderBottom: "1px solid #212736",
                                paddingBottom: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    margin: "10px 0",
                                    color: "#9EA2AE",
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        fontSize: {
                                            xs: "14px",
                                            md: "16px"
                                        },
                                        fontWeight: "500",
                                        lineHeight: "20px"
                                    },
                                    children: "Contact Us"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        fontSize: {
                                            xs: "14px",
                                            md: "16px"
                                        },
                                        fontWeight: "500",
                                        lineHeight: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                padding: "6px 0"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                style: {
                                                    cursor: "pointer",
                                                    textDecoration: "none",
                                                    color: "white"
                                                },
                                                href: "tel:+918384030103",
                                                children: "+91 8384030103"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                padding: "6px 0"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                style: {
                                                    cursor: "pointer",
                                                    textDecoration: "none",
                                                    color: "white",
                                                    padding: "6px 0"
                                                },
                                                href: "mailto:contact@gromo.in",
                                                children: "contact@gromo.in"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    style: {
                        background: "#393F50",
                        color: "#393F50",
                        height: "2px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "block",
                            md: "flex"
                        }
                    },
                    style: {
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0px 8px 8px 8px",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                display: {
                                    xs: "grid",
                                    md: "flex"
                                }
                            },
                            style: {
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                gridTemplateColumns: "1fr 1fr"
                            },
                            children: [
                                {
                                    path: "/privacy-policy",
                                    text: "Privacy policy"
                                },
                                {
                                    path: "/term-condition",
                                    text: "Terms & Conditions"
                                },
                                {
                                    path: "/data-storage-policy",
                                    text: "Data Storage Policy"
                                }
                            ].map((obj, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: obj.path,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontSize: {
                                                xs: "14px",
                                                md: "16px"
                                            },
                                            fontWeight: "500",
                                            lineHeight: "20px",
                                            margin: {
                                                xs: "10px 0",
                                                md: "10px 8px"
                                            }
                                        },
                                        children: obj.text
                                    })
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "#9EA2AE",
                            marginTop: 2,
                            suppressHydrationWarning: true,
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " GroMo. All rights reserved."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    width: "90%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: {
                            background: "transparent",
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                            style: {
                                backgroundColor: "#212736",
                                color: "white",
                                padding: 0
                            },
                            elevation: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        onClick: ()=>setMoreAbout(!moreAbout),
                                        children: [
                                            "More About GroMo",
                                            moreAbout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "About GroMo"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        children: "Do you want to earn money online without investment? Download GroMo to earn extra income from home today!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What is GroMo ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "GroMo is the best money-earning app that will help you in\n                          starting a business without any investment. Become a GroMo\n                          partner by downloading the GroMo app from Play Store and\n                          sell financial products from different brands to customers\n                          and earn over ₹1,00,000 every month."
                                                        },
                                                        {
                                                            text: "You can attend free training, learn how to sell financial\n                          products to customers and start earning."
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "Who can become a GroMo Partner ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "You can be a working professional, a businessman, a\n                          student or a housewife - our app is a one-stop solution\n                          for anybody looking to learn and earn money by selling\n                          financial products. Other than your primary source of\n                          income, you can easily earn extra money from home by\n                          joining GroMo."
                                                        },
                                                        {
                                                            text: "GroMo is one of the best side income sources where you can\n                          engage customers by sharing content with them and getting\n                          the financial product activated."
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What are the benefits of working with GroMo?"
                                                    }),
                                                    [
                                                        {
                                                            title: "Zero Investment business",
                                                            content: "Start your own business with 0 investment"
                                                        },
                                                        {
                                                            title: "Work from homes",
                                                            content: "Get one of the best at-home job opportunities"
                                                        },
                                                        {
                                                            title: "Quick payout",
                                                            content: "Shortest payout cycle in the market"
                                                        },
                                                        {
                                                            title: "Side income source",
                                                            content: "One of the best extra income sources"
                                                        },
                                                        {
                                                            title: "Great customer service",
                                                            content: "Grow your business with help from our customer support team"
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            children: [
                                                                " ",
                                                                i + 1,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                    children: [
                                                                        " ",
                                                                        item.title,
                                                                        " "
                                                                    ]
                                                                }),
                                                                ": ",
                                                                item.content,
                                                                " "
                                                            ]
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What financial brands can you sell ?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "You can start your online business at investment with us today. Sell financial products from next-gen brands like Axis bank, Kotak 811 bank, Upstox, Paytm Money, Freecharge, Bajaj Finserv, etc. and earn extra income online without investment."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "You can sell financial products from the following brand categories:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: [
                                                            "Savings accounts",
                                                            "Credit cards",
                                                            "Demat accounts",
                                                            "Credit accounts",
                                                            "Loan",
                                                            "Investments"
                                                        ].map((text, i)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: text
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "...and many other fantastic financial products with our at-home money earning business. Like what we do? Great, there's more!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What are the features of GroMo ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "GroMo is a great platform to sell financial products.\n                         Trust us, you won't find a better way to earn extra online\n                         without investment. Your customers will be happy to get\n                         access to multiple financial products with you and you\n                         will be happy to earn more income from home, all in one\n                         app."
                                                        },
                                                        {
                                                            text: "You can even build a team through referrals and boost your\n                          earning with our app to make money. Here's is a list of\n                          GroMo features you would love:"
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: [
                                                            {
                                                                title: "Get educated",
                                                                content: "Upskill with our free online courses and webinars and become a certified financial advisor while still doing home based work."
                                                            },
                                                            {
                                                                title: "Manage customers",
                                                                content: "Manage your customers and track their status in your GroMo App. Moreover, you can set up reminders to follow up with your customers."
                                                            },
                                                            {
                                                                title: "Engage your customers",
                                                                content: "Keep your audience engaged with personalized content, website and visiting cards to sell financial products."
                                                            },
                                                            {
                                                                title: "Refer and earn",
                                                                content: "Take full advantage of our fantastic referral policy and refer people in your network to GroMo on a regular basis."
                                                            },
                                                            {
                                                                title: "Track your earnings",
                                                                content: " Use your in-app wallet to keep track of your earnings and transfer money to your bank account."
                                                            },
                                                            {
                                                                title: "Data security",
                                                                content: "Securely maintain customer data in your financial app without worrying about any data safety issues."
                                                            }
                                                        ].map((item, i)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                variant: "body1",
                                                                children: [
                                                                    i + 1,
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                        children: item.title
                                                                    }),
                                                                    " : ",
                                                                    item.content
                                                                ]
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: [
                                                            "Get ready to earn money without investment with GroMo. Download our financial app today",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                style: {
                                                                    color: "#4D71D0",
                                                                    margin: "0px 5px",
                                                                    cursor: "pointer"
                                                                },
                                                                href: Constants/* appLink */.ze,
                                                                children: "Google Play Store"
                                                            }),
                                                            "start your job from home."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_AppFooter = (AppFooter);


/***/ })

}]);